import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportVisitsResponse } from "./type";

export async function exportVisits(
  locationId?: string,
): Promise<ExportVisitsResponse> {
  const params = new URLSearchParams();

  if (locationId) {
    params.append("locationId", locationId);
  }

  let url = apiPaths.visits.export;

  if (params) {
    url += `?${params}`;
  }

  const response = await apiClient.get<ExportVisitsResponse>(url);

  return response.data;
}
